import React from "react";
import s from "./UnlockedSongLessonsPage.module.scss";
import {useUnlockedSongLessonsPageLogic} from "./UnlockedSongLessonsPage.logic";
import LoadingAnimation2 from "../../components/loadingAnimation/LoadingAnimation2";
import TabbedNavigation from "../../components/tabbedNavigation/TabbedNavigation";
import {LibraryLessonGrid} from "../../components/songLibrary/LibraryLessonGrid";
import {FontIcon} from "../../components/common/FontIcon";
import {appPagePaths} from "../../config/config";
import playbackOrchestrator from "../../services/playbackOrchestrator/playbackOrchestrator";

export interface IUnlockedSongLessonsPageProps {
}

export default function UnlockedSongLessonsPage({} :IUnlockedSongLessonsPageProps) {
  const {
    title, 
    bonusContentText, 
    isLoading,
    songArrangementWithProgress,
    scrollableContentRef,
    onScrollHandler,
  } = useUnlockedSongLessonsPageLogic();

  return <div className={s.container}>
    {isLoading ? <LoadingAnimation2/> : null}
    <header className={s.header}>
      {/* Use the useNavigate hook instead of using window.location.hash directly */}
      <button
        className={s.backButton}
        title={"Go back"}
        aria-label={"Go back"}
        onClick={()=> { playbackOrchestrator.stop(); window.location.hash = appPagePaths.bootCampPage; }}>
        <FontIcon icon={"icon-arrow-left"}/>
      </button>
      <h1>
        {/** The non-breaking space reduces layout shift - a simple space does not. */}
        {title ? `${title} — Bonus Songs` : <>&nbsp;</>}
      </h1>
    </header>
    <main className={s.lessons} ref={scrollableContentRef} onScroll={onScrollHandler}>
      {bonusContentText ? <div className={s.bonusContentText}>{bonusContentText}</div> : null}
      <LibraryLessonGrid songArrangements={songArrangementWithProgress} />
    </main>
    <footer className={s.footer}>
      <TabbedNavigation/>
    </footer>
  </div>;
}
